import { Component, Input, OnInit } from "@angular/core";
import { PopoverController } from "@ionic/angular";
import { GameHubControllerService } from "src/app/services/gameHub/game-hub-controller";
import { GameTileService } from "src/app/services/game-tile/game-tile.service";
import { StructureHelperService } from "src/app/services/structure/structure-helper.service";
import { Navigator } from "src/app/services/routing/navigator";
@Component({
  selector: "app-popover-available-games",
  templateUrl: "./popover-available-games.component.html",
  styleUrls: ["./popover-available-games.component.scss"],
})
export class PopoverAvailableGamesComponent implements OnInit {
  @Input() data: any;

  imagePath = "";

  constructor(
    private gameHubControllerService: GameHubControllerService,
    private gameTileService: GameTileService,
    private navigator: Navigator,
    private popoverCtrl: PopoverController,
    private structureHelper: StructureHelperService,
  ) {
    this.imagePath = this.gameTileService.galleryImagePath;
  }

  ngOnInit() {
  }

  getGameImage(gameId) {
    const gameData = this.structureHelper.getGameById(gameId);
    return gameData?.imagename;
  }

  protected launchGameWithId(gameId) {
    this.navigator.dismissAll('');
    const gameData = this.structureHelper.getGameById(gameId);
    setTimeout(() => {
      this.gameHubControllerService.launchCasinoGame(gameData);
    }, 1000);
  }

  closePopover() {
    this.popoverCtrl.dismiss(true);
  }
}
